import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowRight, FaDownload } from 'react-icons/fa';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-modern">
      {/* Background Pattern */}
      <div className="hero-bg-pattern">
        <div className="hero-bg-gradient"></div>
      </div>

      <div className="hero-container">
        <div className="hero-grid">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-content-modern"
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              className="hero-intro"
            >
              <p className="hero-greeting">Hello, I'm</p>
              <h1 className="hero-title">
                Itrat Zehra
                <br />
                <span className="hero-title-accent">Jassani</span>
              </h1>
            </motion.div>

            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
              className="hero-subtitle"
            >
              I lead complex software projects from idea to launch.
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.6 }}
              className="hero-description"
            >
              I'm a Technical Project Manager with a software engineering background and experience
              delivering digital products across banking, fintech, healthcare, and developer tools.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.6 }}
              className="hero-buttons"
            >
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate('/projects')}
                className="btn-modern-primary"
              >
                <span>Explore My Work</span>
                <FaArrowRight />
              </motion.button>

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate('/contact')}
                className="btn-modern-secondary"
              >
                <span>Contact Me</span>
                <FaDownload />
              </motion.button>
            </motion.div>
          </motion.div>

          {/* Visual Element */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="hero-visual"
          >
            <div className="hero-visual-content">
              {/* Professional Image Container */}
              <div className="hero-image-container">
                <div className="hero-image-placeholder">
                  <img 
                    src="/profile.png" 
                    alt="Itrat Zehra Jassani - Senior Project Manager & Software Engineer"
                    className="hero-profile-img"
                    onError={(e) => {
                      // Fallback if image doesn't load
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  {/* Fallback placeholder */}
                  <div className="hero-image-text hero-fallback" style={{display: 'none'}}>
                    <div className="hero-initials">IJ</div>
                    <div className="hero-image-subtitle">Professional Photo</div>
                  </div>
                </div>
                
                {/* Achievement Badge */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  animate={{ scale:1 }}
                  transition={{ delay: 0.8 }}
                  className="hero-achievement-badge"
                >
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-teal rounded-lg flex items-center justify-center text-white font-bold">
                      🥈
                    </div>
                    <div>
                      <div className="font-semibold text-navy">Silver Medalist</div>
                      <div className="text-sm text-gray-600">Academic Excellence</div>
                    </div>
                  </div>
                </motion.div>


                
                
                {/* Experience Badge */}
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ delay: 1.2, type: "spring", stiffness: 200 }}
                  className="hero-experience-badge"
                >
                  <div className="badge-content">
                    <div className="badge-number">7+</div>
                    <div className="badge-label">Years</div>
                  </div>
                </motion.div>
              </div>
            </div>

            {/* Background Decoration */}
            <div className="hero-decoration"></div>
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 0.6 }}
        className="hero-scroll-indicator"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="scroll-mouse"
        >
          <div className="scroll-dot"></div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
